<div class="header">
  <div class="page_header">
    <div class="left">
      <app-page-close-button (click)="goBack()"></app-page-close-button>
      <div class="title">Item Filing</div>
    </div>
    <div class="right">
      @if (!readOnlyMode) {
        <button class="secondary_button" (click)="goBack()">Cancel</button>
        <button class="primary_button" (click)="submitForm()">@if (editingEnabled) {
          Update
        } @else {
          Save
        }</button>
      }
    </div>
  </div>
  <div class="horizontal_tabs">
    <div class="tabs">
      <div class="tab" (click)="scrollToSection('allSection')">
        <div class="tab_name" [class.tab_name_active]="selectedTab === tabs.ALL_SECTION">All</div>
        <div class="bottom_border" [class.bottom_border_active]="selectedTab === tabs.ALL_SECTION "></div>
      </div>

      <div class="tab" (click)="scrollToSection('itemDetailsSection')">
        <div class="tab_name" [class.tab_name_active]="selectedTab === tabs.ITEM_DETAILS_SECTION">Item Details</div>
        <div class="bottom_border" [class.bottom_border_active]="selectedTab === tabs.ITEM_DETAILS_SECTION"></div>
      </div>

      <div class="tab" (click)="scrollToSection('containerDetailsSection')">
        <div class="tab_name" [class.tab_name_active]="selectedTab === tabs.CONTAINER_DETAILS_SECTION">Container Details
        </div>
        <div class="bottom_border" [class.bottom_border_active]="selectedTab === tabs.CONTAINER_DETAILS_SECTION"></div>
      </div>
    </div>
    <div class="divider"></div>
  </div>
</div>

<div class="full_page_container" (scroll)="handleScroll($event)">
  <form [formGroup]="itemFilingForm">
    <section #allSection id="allSection" class="igm_details_form">
      <div class="section_title">IGM Details</div>
      <div class="divider"></div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="igmNo" class="label required_field_label">IGM No </label>
          <input
            id="igmNo"
            type="text"
            formControlName="igmNo"
            placeholder="Enter IGM No"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('igmNo')?.invalid && itemFilingForm.get('igmNo')?.touched}">
            <small *ngIf="itemFilingForm.get('igmNo')?.errors?.['required']">IGM No. is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="itemNo" class="label required_field_label">Item No </label>
          <input id="itemNo" type="number" formControlName="itemNo" placeholder="Enter Item Number"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('itemNo')?.invalid && itemFilingForm.get('itemNo')?.touched}">
            <small *ngIf="itemFilingForm.get('itemNo')?.errors?.['required']">Item No. is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="subItemNo" class="label required_field_label">Sub Item No</label>
          <input id="subItemNo" type="number" formControlName="subItemNo" placeholder="Enter Sub Item No"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('subItemNo')?.invalid && itemFilingForm.get('subItemNo')?.touched}">
            <small *ngIf="itemFilingForm.get('subItemNo')?.errors?.['required']">Sub Item No. is required</small>
          </div>
        </div>
        <div class="form-group" #formField>
          <label for="igmDate" class="label">IGM Date</label>
          <!-- <input id="igmDate" type="date" formControlName="igmDate" placeholder="Enter IGM Date" /> -->
          <app-date-picker [id]="'igmDate'" [type]="'date'" [formControlName]="'igmDate'" id="igmDate"
                           [placeholder]="'Enter IGM Date'">
          </app-date-picker>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="blNo" class="label">MBL No </label>
          <input id="blNo" type="text" formControlName="blNo" placeholder="Enter MBL Number" />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('blNo')?.invalid && itemFilingForm.get('blNo')?.touched}">
            <small *ngIf="itemFilingForm.get('blNo')?.errors?.['required']">MBL No. is required</small>
          </div>
        </div>
        <div class="form-group" #formField>
          <label for="blDate" class="label">MBL Date </label>
          <app-date-picker [id]="'blDate'" [type]="'date'" [formControlName]="'blDate'"
                           [placeholder]="'Select MBL Date'"></app-date-picker>
        </div>
        <div class="form-group" #formField>
          <label for="hblNo" class="label">HBL No </label>
          <input id="hblNo" type="text" formControlName="hblNo" placeholder="Enter HBL Number" />
        </div>
        <div class="form-group" #formField>
          <label for="hblDate" class="label">HBL Date </label>
          <app-date-picker [id]="'hblDate'" [type]="'date'" id="hblDate" [formControlName]="'hblDate'"
                           [placeholder]="'Select HBL Date'"></app-date-picker>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="vesselId" class="label required_field_label">Vessel Name </label>
          <app-autocomplete-dropdown
            id="vesselId"
            formControlName="vesselId"
            [placeholder]="'Select Vessel'"
            [apiUrl]="'v1/vessel-port-train-details/list'"
            [selectFields]="['id','vesselName','viaNo']"
            [limit]="10"
            [filterByKeys]="['vesselName', 'viaNo']"
            [orderBy]="{ vesselName: 'asc' }"
            [filterByKey]="'vesselName'"
            [bindLabel]="'vesselName'"
            [bindValue]="'id'"
            [displayColumns]="[
                        { key: 'vesselName', header: 'Vessel Name' },
                        { key: 'viaNo', header: 'VIA Number' },
                    ]"
            (suggestionSelected)="autoPopulateViaNumber($event)"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('vesselId')?.invalid && itemFilingForm.get('vesselId')?.touched}">
            <small *ngIf="itemFilingForm.get('vesselId')?.errors?.['required']">Vessel is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="viaNo" class="label">VIA No </label>
          <input type="text" id="viaNo" formControlName="viaNo" placeholder="Enter Via Number" readonly>
        </div>

        <div class="form-group" #formField>
          <label for="portOfLoading" class="label">POL </label>
          <app-autocomplete-dropdown
            id="portOfLoading"
            formControlName="portOfLoading"
            [placeholder]="'Enter POL'"
            [apiUrl]="'v1/locations/list'"
            [limit]="10"
            [filterByKeys]="['NAME_CONTAINS']"
            [orderBy]="{ name: 'asc' }"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [additionalFilters]="[
              {
                'name': 'IS_ACTIVE',
                'alias': 'active',
                'operator': 'EQ',
                'value': ['true']
              }
            ]"
            [displayColumns]="[
                        { key: 'name', header: 'Location Name' },
                        { key: 'panNumber', header: 'PAN Number' },
                    ]"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
        </div>
        <div class="form-group" #formField>
          <label for="shippingLineId" class="label">Shipping Line</label>
          <app-autocomplete-dropdown
            id="shippingLineId"
            formControlName="shippingLineId"
            [placeholder]="'Select Shipping Line'"
            [apiUrl]="'v1/customers/list'"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [orderBy]="{ name: 'asc' }"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
                      { key: 'name', header: 'Customer Name' },
                      { key: 'code', header: 'Customer Code' },
                  ]"
            [additionalFilters]="[
              {
                'name': 'IS_ACTIVE',
                'alias': 'active',
                'operator': 'EQ',
                'value': ['true']
              },
              {
                'name': 'CUSTOMER_TYPE_CONTAINS',
                'alias': 'customerType',
                'operator': 'IN',
                'value': ['LINE']
              }
            ]"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
        </div>
      </div>
    </section>
    <section class="account_holder_details_form">
      <div class="section_title">Account Holder Details</div>
      <div class="divider"></div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="accountHolderId" class="label required_field_label">Account Holder</label>
          <app-autocomplete-dropdown
            id="accountHolderId"
            formControlName="accountHolderId"
            [placeholder]="'Enter Account Holder'"
            [apiUrl]="'v1/customers/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
              { key: 'name', header: 'Name' },
              { key: 'code', header: 'Code' }
            ]"
            [additionalFilters]="[
              {
                'name': 'IS_ACTIVE',
                'alias': 'active',
                'operator': 'EQ',
                'value': ['true']
              }
            ]"
            [ngClass]="{'form_error': itemFilingForm.get('accountHolderId')?.invalid && itemFilingForm.get('accountHolderId')?.touched && itemFilingForm.get('accountHolderId')?.errors}"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('accountHolderId')?.invalid && itemFilingForm.get('accountHolderId')?.touched}">
            <small *ngIf="itemFilingForm.get('accountHolderId')?.errors?.['required']">Account Holder is
              required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="chaId" class="label required_field_label">CHA</label>
          <app-autocomplete-dropdown
            id="chaId"
            formControlName="chaId"
            [placeholder]="'Enter CHA'"
            [apiUrl]="'v1/customers/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
              { key: 'name', header: 'Name' },
              { key: 'code', header: 'Code' }
            ]"
            [additionalFilters]="[
              {
                'name': 'IS_ACTIVE',
                'alias': 'active',
                'operator': 'EQ',
                'value': ['true']
              },
              {
                'name': 'CUSTOMER_TYPE_CONTAINS',
                'alias': 'customerType',
                'operator': 'IN',
                'value': ['CHA']
              }
            ]"
            [ngClass]="{
      form_error:
        itemFilingForm.get('chaId')?.invalid &&
        itemFilingForm.get('chaId')?.touched &&
        itemFilingForm.get('chaId')?.errors
    }"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('chaId')?.invalid && itemFilingForm.get('chaId')?.touched}">
            <small *ngIf="itemFilingForm.get('chaId')?.errors?.['required']">CHA is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="importerFromIgm" class="label">Importer from IGM</label>
          <input
            id="importerFromIgm"
            formControlName="importerFromIgm"
            type="text"
            placeholder="Enter Importer From IGM"
            readonly
          >
        </div>

        <div class="form-group" #formField>
          <label for="importerAddressFromIgm" class="label">Importer address from IGM </label>
          <input
            id="importerAddressFromIgm"
            formControlName="importerAddressFromIgm"
            type="text"
            placeholder="Enter Importer address from IGM"
            readonly
          >
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" #formField>
          <label for="consigneeId" class="label required_field_label">Consignee </label>
          <app-autocomplete-dropdown
            id="consigneeId"
            formControlName="consigneeId"
            [placeholder]="'Enter Consignee'"
            [apiUrl]="'v1/customers/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
      { key: 'name', header: 'Name' },
      { key: 'code', header: 'Code' }
    ]"
            [ngClass]="{
      form_error:
        itemFilingForm.get('consigneeId')?.invalid &&
        itemFilingForm.get('consigneeId')?.touched &&
        itemFilingForm.get('consigneeId')?.errors
    }"
            [disable]="readOnlyMode"
            (searchCleared)="clearConsigneeAddress()"
            (suggestionSelected)="autoPopulateConsigneeAddress($event)"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('consigneeId')?.invalid && itemFilingForm.get('consigneeId')?.touched}">
            <small *ngIf="itemFilingForm.get('consigneeId')?.errors?.['required']">Consignee is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="consigneeAddressId" class="label">Consignee Address</label>
        
          <app-multi-select
            id="consigneeAddressId"
            formControlName="consigneeAddressId"
            [placeholder]="'Select Consignee Address'"
            [valueKey]="'id'"
            [displayKey]="'address'"
            [isMultiSelect]="false"
            [options]="consigneeAddressList"
          ></app-multi-select>
          
        </div>

        <div class="form-group" #formField>
          <label for="notifyPartyId" class="label required_field_label">Notify Party </label>
          <app-autocomplete-dropdown
            id="notifyPartyId"
            formControlName="notifyPartyId"
            [placeholder]="'Enter Notify Party'"
            [apiUrl]="'v1/customers/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
                        { key: 'name', header: 'Name' },
                        { key: 'code', header: 'Code' },
                    ]"
            (suggestionSelected)="autoPopulateNotifyParty($event)"
            (searchCleared)="clearNotifyPartyAddress()"
            [ngClass]="{
      form_error:
        itemFilingForm.get('notifyPartyId')?.invalid &&
        itemFilingForm.get('notifyPartyId')?.touched &&
        itemFilingForm.get('notifyPartyId')?.errors
    }"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('notifyPartyId')?.invalid && itemFilingForm.get('notifyPartyId')?.touched}">
            <small *ngIf="itemFilingForm.get('notifyPartyId')?.errors?.['required']">Notify Party is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="notifyPartyAddressId" class="label">Notify Party Address</label>

          <app-multi-select
            id="notifyPartyAddressId"
            formControlName="notifyPartyAddressId"
            [placeholder]="'Select Notify Party Address'"
            [valueKey]="'id'"
            [displayKey]="'address'"
            [isMultiSelect]="false"
            [options]="notifyPartyAddressList"
          ></app-multi-select>
        </div>
      </div>
      <!--      TODO: Add this post discussion-->
      <!--      <div class="form-row">-->
      <!--        <div class="form-group" #formField>-->
      <!--          <label for="shippingLine" class="label required_field_label">Shipping Line</label>-->
      <!--          <app-autocomplete-dropdown-->
      <!--            id="shippingLine"-->
      <!--            formControlName="shippingLine"-->
      <!--            [placeholder]="'Enter Shipping Line'"-->
      <!--            [apiUrl]="'v1/customers/list'"-->
      <!--            [selectFields]="['id', 'name', 'code']"-->
      <!--            [orderBy]="{ name: 'asc' }"-->
      <!--            [filterByKeys]="['name', 'code']"-->
      <!--            [limit]="10"-->
      <!--            [filterByKey]="'name'"-->
      <!--            [bindLabel]="'name'"-->
      <!--            [bindValue]="'id'"-->
      <!--            [displayColumns]="[-->
      <!--                        { key: 'name', header: 'Name' },-->
      <!--                        { key: 'code', header: 'Code' },-->
      <!--                    ]"-->
      <!--            [ngClass]="{-->
      <!--      form_error:-->
      <!--        itemFilingForm.get('shippingLine')?.invalid &&-->
      <!--        itemFilingForm.get('shippingLine')?.touched &&-->
      <!--        itemFilingForm.get('shippingLine')?.errors-->
      <!--    }"-->
      <!--            [disable]="readOnlyMode"-->
      <!--          ></app-autocomplete-dropdown>-->
      <!--          <div class="form_validation_error_new" [ngClass]="{'visible': itemFilingForm.get('shippingLine')?.invalid && itemFilingForm.get('shippingLine')?.touched}">-->
      <!--            <small *ngIf="itemFilingForm.get('shippingLine')?.errors?.['required']">Shipping Line is required</small>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

    </section>
    <section #itemDetailsSection id="itemDetailsSection" class="item_details_form">
      <div class="section_title">Item Details</div>
      <div class="divider"></div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="boeNo" class="label required_field_label">BOE No</label>
          <input id="boeNo" type="text" formControlName="boeNo" placeholder="Enter BOE Number"
                 [ngClass]="{
      form_error:
        itemFilingForm.get('boeNo')?.invalid &&
        itemFilingForm.get('boeNo')?.touched &&
        itemFilingForm.get('boeNo')?.errors
    }" />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('boeNo')?.invalid && itemFilingForm.get('boeNo')?.touched}">
            <small *ngIf="itemFilingForm.get('boeNo')?.errors?.['required']">BOE No. is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="boeDate" class="label required_field_label">BOE Date</label>
          <app-date-picker [id]="'boeDate'" [type]="'date'" [formControlName]="'boeDate'" id="boeDate"
                           [placeholder]="'Select BOE Date'"></app-date-picker>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('boeDate')?.invalid && itemFilingForm.get('boeDate')?.touched}">
            <small *ngIf="itemFilingForm.get('boeNo')?.errors?.['required']">BOE Date is required</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group toggle-group" #formField>
          <app-toggle
            id="smtpMovement"
            [label]="'SMTP'" [toggleId]="'smtpMovement'"
            [isActive]="itemFilingForm.get('smtpMovement')?.value"
            (toggleChange)="onSmtpToggle($event)"
            [disable]="readOnlyMode"
            formControlName="smtpMovement"
          ></app-toggle>
        </div>
        @if (itemFilingForm.get('smtpMovement')?.value) {
          <div class="form-group" #formField>
            <label for="smtpNo" class="label required_field_label">SMTP No</label>
            <input id="smtpNo" type="text" formControlName="smtpNo"
                   [ngClass]="{
      form_error:
        itemFilingForm.get('smtpNo')?.invalid &&
        itemFilingForm.get('smtpNo')?.touched &&
        itemFilingForm.get('smtpNo')?.errors
    }"
            />
            <div class="form_validation_error_new"
                 [ngClass]="{'visible': itemFilingForm.get('smtpNo')?.invalid && itemFilingForm.get('smtpNo')?.touched}">
              <small *ngIf="itemFilingForm.get('smtpNo')?.errors?.['required']">SMTP Number is required</small>
            </div>
          </div>
        }
      </div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="numberOfPackages" class="label required_field_label">Total NOP</label>
          <input
            id="numberOfPackages"
            formControlName="numberOfPackages"
            type="text"
            placeholder="Enter Total NOP"
            [ngClass]="{
      form_error:
        itemFilingForm.get('numberOfPackages')?.invalid &&
        itemFilingForm.get('numberOfPackages')?.touched &&
        itemFilingForm.get('numberOfPackages')?.errors
    }"
          >
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('numberOfPackages')?.invalid && itemFilingForm.get('numberOfPackages')?.touched}">
            <small *ngIf="itemFilingForm.get('numberOfPackages')?.errors?.['required']">Number of packages is
              required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="packageTypeId" class="label">Package Type</label>
          <app-autocomplete-dropdown
            id="packageTypeId"
            formControlName="packageTypeId"
            [placeholder]="'Enter Package Type'"
            [apiUrl]="'v1/packages/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [additionalFilters]="[
              {
                'name': 'ACTIVE_EQUALS',
                'alias': 'active',
                'value': [true]
              }
            ]"
            [displayColumns]="[
                        { key: 'name', header: 'Name' },
                        { key: 'code', header: 'Code' },
                    ]"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
        </div>

        <div class="form-group" #formField>
          <label for="grossWeight" class="label required_field_label">Gross Weight (In MT)</label>
          <input id="grossWeight" type="number" formControlName="grossWeight"
                 placeholder="Enter Gross Weight (In MT)"
                 [ngClass]="{
      form_error:
        itemFilingForm.get('grossWeight')?.invalid &&
        itemFilingForm.get('grossWeight')?.touched &&
        itemFilingForm.get('grossWeight')?.errors
    }"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('grossWeight')?.invalid && itemFilingForm.get('grossWeight')?.touched}">
            <small *ngIf="itemFilingForm.get('grossWeight')?.errors?.['required']">Number of packages is
              required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="grossVolume" class="label">Volume (In CBM)</label>
          <input id="grossVolume" type="number" formControlName="grossVolume" placeholder="Enter Volume (In CBM)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group toggle-group" #formField>
          <app-toggle id="dpd" [label]="'DPD'" [toggleId]="'dpd'" [isActive]="itemFilingForm.get('dpd')?.value"
                      (toggleChange)="onDpdToggle($event)" [disable]="readOnlyMode"></app-toggle>
        </div>
        <div class="form-group toggle-group" #formField>
          <app-toggle [label]="'Hazardous'" [toggleId]="'hazardous'" [isActive]="itemFilingForm.get('hazardous')?.value"
                      formControlName="hazardous"
                      (toggleChange)="onHazardousChange($event)" [disable]="readOnlyMode"></app-toggle>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group" #formField>
          <label for="assessableValue" class="label required_field_label">Assessable Value</label>
          <input id="assessableValue" type="number" formControlName="assessableValue"
                 placeholder="Enter Assessable Value"
                 [ngClass]="{
      form_error:
        itemFilingForm.get('assessableValue')?.invalid &&
        itemFilingForm.get('assessableValue')?.touched &&
        itemFilingForm.get('assessableValue')?.errors
    }"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('assessableValue')?.invalid && itemFilingForm.get('assessableValue')?.touched}">
            <small *ngIf="itemFilingForm.get('assessableValue')?.errors?.['required']">Assessable Value is
              required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="dutyValue" class="label required_field_label">Duty Value</label>
          <input id="dutyValue" type="number" formControlName="dutyValue" placeholder="Enter Duty Value"
                 [ngClass]="{
      form_error:
        itemFilingForm.get('dutyValue')?.invalid &&
        itemFilingForm.get('dutyValue')?.touched &&
        itemFilingForm.get('dutyValue')?.errors
    }"
          />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('dutyValue')?.invalid && itemFilingForm.get('dutyValue')?.touched}">
            <small *ngIf="itemFilingForm.get('dutyValue')?.errors?.['required']">Duty Value is required</small>
          </div>
        </div>
      </div>
      <div class="form-row">

        <div class="form-group" #formField>
          <label for="goodsDescription" class="label">Cargo Description</label>
          <input id="goodsDescription" type="text" formControlName="goodsDescription"
                 placeholder="Enter Cargo Description" />
        </div>

        <div class="form-group" #formField>
          <label for="commodityId" class="label required_field_label">Commodity</label>
          <app-autocomplete-dropdown
            id="commodityId"
            formControlName="commodityId"
            [placeholder]="'Enter Commodity Name'"
            [apiUrl]="'v1/commodities/list'"
            [orderBy]="{ name: 'asc' }"
            [filterByKeys]="['NAME_CONTAINS', 'CODE_CONTAINS']"
            [limit]="10"
            [filterByKey]="'name'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
                        { key: 'name', header: 'Name' },
                        { key: 'code', header: 'Code' },
                        { key: 'commodityCategory.name', header: 'Commodity Category' },
                    ]"
            [disable]="readOnlyMode"
          ></app-autocomplete-dropdown>
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('commodityId')?.invalid && itemFilingForm.get('commodityId')?.touched}">
            <small *ngIf="itemFilingForm.get('commodityId')?.errors?.['required']">Commodity is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="examinationType" class="label">Examination type</label>
          <!-- <select id="examinationType" formControlName="examinationType">
            <option value="SEAL_CUT_AND_EXAMINATION">Seal Cut and Examination</option>
            <option value="RMS_AND_EXAMINATION">RMS and Examination</option>
            <option value="RMS">RMS</option>
          </select> -->
          <app-multi-select
            id="examinationType"
            formControlName="examinationType"
            [placeholder]="'Select Examination Type'"
            [valueKey]="'value'"
            [displayKey]="'label'"
            [isMultiSelect]="false"
            [options]="examinationTypeOptions"
          ></app-multi-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" #formField>
          <label for="doNo" class="label">DO NO</label>
          <input id="doNo" type="text" formControlName="doNo" placeholder="Enter DO No" />
          <div class="form_validation_error_new"
               [ngClass]="{'visible': itemFilingForm.get('doNo')?.invalid && itemFilingForm.get('doNo')?.touched}">
            <small *ngIf="itemFilingForm.get('doNo')?.errors?.['required']">DO No is required</small>
          </div>
        </div>

        <div class="form-group" #formField>
          <label for="doDate" class="label">DO Date</label>
          <app-date-picker
          [id]="'doDate'"
          [type]="'date'"
          [placeholder]="'Select DO Date'"
          [formControlName]="'doDate'"
          ></app-date-picker>
        </div>

        <div class="form-group" #formField>
          <label for="doValidityDate" class="label">DO Validity Date</label>
          <app-date-picker
          [id]="'doValidityDate'"
          [type]="'date'"
          [placeholder]="'Select DO Validity Date'"
          [formControlName]="'doValidityDate'"
          ></app-date-picker>
        </div>

        <div class="form-group" #formField>
          <label for="deliveryModeFromDO" class="label">Delivery Mode from DO</label>
          <app-multi-select
            id="deliveryModeFromDO"
            formControlName="deliveryModeFromDO"
            [placeholder]="'Select Delivery Mode'"
            [valueKey]="'value'"
            [displayKey]="'label'"
            [isMultiSelect]="false"
            [options]="deliveryModeOptions"
          ></app-multi-select>
        </div>

      </div>

      <div class="form-row">
        <div class="form-group toggle-group" #formField>
          <app-toggle [label]="'High Seal'" [toggleId]="'highSeaSaleCustomer'"
                      [isActive]="itemFilingForm.get('highSeaSaleCustomer')?.value"
                      (toggleChange)="onHighSealToggle($event)" [disable]="readOnlyMode"></app-toggle>
        </div>

        @if (isHighSeaSaleCustomer) {
          <div class="form-group" #formField>
            <label for="highSeaSaleCustomerId" class="label required_field_label">High Seal Customer Name</label>
            <app-autocomplete-dropdown
              id="highSeaSaleCustomerId"
              formControlName="highSeaSaleCustomerId"
              [placeholder]="'Enter High Seal Customer Name'"
              [apiUrl]="'v1/customers/list'"
              [orderBy]="{ name: 'asc' }"
              [filterByKeys]="['NAME_CONTAINS']"
              [limit]="10"
              [filterByKey]="'name'"
              [bindLabel]="'name'"
              [bindValue]="'id'"
              [displayColumns]="[
                        { key: 'name', header: 'Name' },
                        { key: 'code', header: 'Code' },
                    ]"
              (suggestionSelected)="autoPopulateHighSealCustomerAddress($event)"
              (searchCleared)="clearHighSeaSaleCustomerAddress()"
              [disable]="readOnlyMode"
            ></app-autocomplete-dropdown>
            <div class="form_validation_error_new"
                 [ngClass]="{'visible': itemFilingForm.get('highSeaSaleCustomerId')?.invalid && itemFilingForm.get('highSeaSaleCustomerId')?.touched}">
              <small *ngIf="itemFilingForm.get('highSeaSaleCustomerId')?.errors?.['required']">High Seal Customer Name
                is required</small>
            </div>
          </div>

          <div class="form-group" #formField>
            <label for="highSeaSaleCustomerAddressId" class="label required_field_label">High Seal Customer Address</label>

            <app-multi-select
            id="highSeaSaleCustomerAddressId"
            formControlName="highSeaSaleCustomerAddressId"
            [placeholder]="'Select Customer Address'"
            [valueKey]="'id'"
            [displayKey]="'address'"
            [isMultiSelect]="false"
            [options]="highSealCustomerAddressList"
            ></app-multi-select>

            <div class="form_validation_error_new"
                 [ngClass]="{'visible': itemFilingForm.get('highSeaSaleCustomerAddressId')?.invalid && itemFilingForm.get('highSeaSaleCustomerAddressId')?.touched}">
              <small *ngIf="itemFilingForm.get('highSeaSaleCustomerAddressId')?.errors?.['required']">High Seal Customer
                Address is required</small>
            </div>
          </div>
        }
      </div>
    </section>
  </form>
  <div class="editable_table_container">
    <div class="table-header">
      <div class="left">
        <div class="title">Associated Containers</div>
        <div class="subtitle">View, Edit and Manage Containers</div>
      </div>
      <div class="right">
        <div class="search-bar-with-suggestions">
          <div class="input-button-group">
            <input type="text" placeholder="Search Containers" class="search-input"
                 [(ngModel)]="searchTerm"  (input)="toggleSuggestionBox($event)" />
            <button class="tertiary_button add-button" (click)="addRecord()">
              <span class="button-icon">+</span> Add New
            </button>
          </div>
          <div class="search-results" *ngIf="showSuggestions">
            <table class="suggestions-table">
              <thead *ngIf="this.searchBarDisplayColumns?.length > 0 && suggestions.length > 0">
              <tr>
                <th *ngFor="let column of this.searchBarDisplayColumns">{{ column.header }}</th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="let result of suggestions"
                (click)="select(result)"
              >
                <td *ngFor="let column of this.searchBarDisplayColumns">
                  <span [innerHTML]="result[column.key] | highlight : searchTerm"></span>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="result loading_results" *ngIf="loading">Loading...</div>
            <div class="result no_results" *ngIf="suggestions.length === 0 && !loading ">
              No results!
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-editable-table
      #containerDetailsSection
      id="containerDetailsSection"
      [tableHeaders]="tableHeaders"
      [tableData]="tableData"
      (dataDeleted)="deleteRecord($event)"
      [uniqueId]="'id'"
      [disableTable]="readOnlyMode"
      [bulkDeletionAllowed]="true"
      [noDataFoundErrorMsg]="'No containers are currently associated with this cargo. Please add one or more to ensure proper tracking.'"
      [noDataFoundIcon]="'assets/icons/empty_container_data.svg'"
    ></app-editable-table>
  </div>
</div>
